import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';

interface TabPanelProps {
	tabHeader: string;
	children: ReactNode;
	value: number;
	index: number;
	removeHeaderMarginBottom?: boolean;
	appointmentScheduled?: boolean;
}

const TabPanel = (props: TabPanelProps) => {
	const { tabHeader, children, value, index, removeHeaderMarginBottom, appointmentScheduled } = props;
	const { t } = useTranslation('tabPanel');

	return (
		<Container
			role="tabpanel"
			hidden={value !== index}
			id={`vertical-tabpanel-${index}`}
			aria-labelledby={`vertical-tab-${index}`}
			disableGutters
		>
			{value === index && (
				<Box sx={{ px: { xs: 2, sm: 3 }, pt: { xs: 1, sm: 2 } }}>
					<Typography variant="overline" color="success.dark">
						{appointmentScheduled ? t('apptScheduled') : t('apptAssistant')}
					</Typography>
					<Typography data-test-id="form-header" variant="header2" mb={removeHeaderMarginBottom ? 0 : 2}>
						{tabHeader}
					</Typography>
					{children}
				</Box>
			)}
		</Container>
	);
};

export default TabPanel;
